import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { Fragment } from 'react';
import { DateBanner } from './DateBanner';
import { partitionListBy } from '../../helpers';
import { SystemMessageGroup } from './SystemMessageGroup';
import { UserMessageGroup } from './UserMessageGroup';

var differentAuthor = function differentAuthor(m1, m2) {
  return m1.type !== m2.type || m1.type === 'User' && m1.createdBy.username !== m2.createdBy.username;
};

var Default = function Default(_ref) {
  var dateBanner = _ref.dateBanner,
      messageGroups = _ref.messageGroups;
  return /*#__PURE__*/React.createElement(Fragment, null, dateBanner, messageGroups);
};

export var MessagesByDate = function MessagesByDate(props) {
  var Component = props.renderMessagesByDate || Default;
  return /*#__PURE__*/React.createElement(Component, {
    dateBanner: /*#__PURE__*/React.createElement(DateBanner, {
      date: props.messages.first().createdAt
    }),
    messageGroups: partitionListBy(differentAuthor, props.messages).map(function (messages) {
      return {
        discussion: props.discussion,
        profile: props.profile,
        messages: messages,
        actions: props.actions,
        key: messages.first().id,
        Component: messages.first().type === 'User' ? UserMessageGroup : SystemMessageGroup
      };
    }).map(function (_ref2) {
      var Component = _ref2.Component,
          props = _objectWithoutProperties(_ref2, ["Component"]);

      return /*#__PURE__*/React.createElement(Component, props);
    })
  });
};